import { React, useState, useEffect } from 'react';
import LandingHeader from './header';
import Banner4 from "../assets/images/Banner-2.png"
import "./landingpage.css"
import pizza from "../assets/images/pizza.jpg"
import { ReactComponent as Location } from '../assets/images/svgIcons/locationIcon.svg';
import { ReactComponent as LocationMain } from '../assets/images/svgIcons/landingpage/Location.svg';
import { ReactComponent as Food } from '../assets/images/svgIcons/landingpage/food.svg';
import { ReactComponent as Card } from '../assets/images/svgIcons/landingpage/Card.svg';
import { ReactComponent as Gift } from '../assets/images/svgIcons/landingpage/gift.svg';
import Service from './service';
import Review from './review';
import OfferCard from './offerCard';
import ContactForm from './contactForm';
import Footer from './footer';
import ApiService from '../services/apiService';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';

const LandingPage = () => {

    const [userCountry, setUserCountry] = useState('');
    const [selectedCity, setSelectedCity] = useState('');
    const [cities, setCities] = useState([]);
    const [loading, setLoading] = useState(true);
    const [menu, setMenu] = useState([]);
    const navigate = useNavigate()
    const [countries, setCountries] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState('');
    
    useEffect(() => {
        fetch('https://restcountries.com/v3.1/all')
            .then((response) => response.json())
            .then((data) => setCountries(data));
    }, []);

    const handleCountryChange = (e) => {
        setSelectedCountry(e.target.value);
        fetch(`http://api.geonames.org/searchJSON?country=${e.target.value}&maxRows=10&username=shahzaibawan`)
            .then((response) => response.json())
            .then((data) => setCities(data.geonames));
            
    };

    useEffect(() => {
        const fetchUserCountry = async () => {
            try {
                const response = await fetch('https://geolocation-db.com/json/');
                const data = await response.json();
                setUserCountry(data.country_name.toLowerCase());
                setLoading(false);
            } catch (error) {
                console.error('Error fetching user country:', error);
            }
        };

        fetchUserCountry();
    }, []);
    useEffect(() => {
        GetMenu();
    }, []);

    useEffect(() => {
        const fetchCities = async () => {
            try {
                if (userCountry) {
                    const response = await fetch(`https://api.teleport.org/api/urban_areas/slug:${userCountry}/`);
                    const data = await response.json();
                    const cityData = data['_links']['ua:item'].map((city) => ({
                        value: city.name.toLowerCase(),
                        label: city.name,
                    }));
                    setCities(cityData);
                }
            } catch (error) {
                console.error('Error fetching cities:', error);
            }
        };

        fetchCities();
    }, [userCountry]);
    const GetMenu = async () => {
        try {
            const apiService = new ApiService();
            let param = `?PageNo=1&PageSize=20`
            let res = await apiService.getApiParamater("GET_MENU", param);

            setMenu(res.data.result);
        } catch (error) {
            console.error('Error fetching menu data:', error);
        }
    };
    const handleItem = () => {
        navigate('/customer/menu')
    }
    const handleCityChange = (selectedOption) => {
        setSelectedCity(selectedOption?.value);
    };

    return (
        <div className=''>
            <LandingHeader />
            <div className='pt-5'>
                {/* <ImageSlider /> */}
                <img src={Banner4} class="d-block w-100" alt="..." />
                <div className='mx-3'>
                    <div className='deliveryBx p-4 px-5'>
                        <div className='row'>
                            <div className='col-lg-3 center'>
                                <img src={pizza} className='imgbox center' />
                            </div>
                            <div className='col-lg-6 pt-3'>
                                <div className='maintx p-2'>Food Delivery Restaurant</div>
                                <div className='d-flex justify-content-between'>
                                    <div className='orderBtn'>{userCountry.charAt(0).toUpperCase() + userCountry.slice(1)}</div>
                                    <Select styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#fff ' : '#fff',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#ffff ',
                                            },
                                        }),
                                    }}
                                        className='w-50'
                                        onChange={handleCityChange}
                                        options={cities}
                                        value={selectedCity ? { value: selectedCity, label: selectedCity.charAt(0).toUpperCase() + selectedCity.slice(1) } : null}
                                    />
                                    <div className='orderBtn'>Search</div>
                                </div>
                                <div className='findbx center mt-3'>
                                    <div className='tx'>
                                        <Location /> Find restaurant nearby my location
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-3 center'>
                                <img src={pizza} className='imgbox' />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='p-5'>
                    <div className='hadding'>
                        HOW ORDER FOOD ONLINE WORKS
                    </div>
                    <div className='d-flex justify-content-between container py-4'>
                        <div className=''>
                            <div className='Gbox'>
                                <LocationMain />
                            </div>
                            <div className='center choose pt-2'>Enter Your Location</div>
                        </div>
                        <div className=''>
                            <div className='Gbox'>
                                <Food />
                            </div>
                            <div className='center choose pt-2'>Choose Restaurant <br /> And Order</div>
                        </div>
                        <div className=''>
                            <div className='Gbox'>
                                <Card />
                            </div>
                            <div className='center choose pt-2'>Pay By Cash Or Card</div>
                        </div>
                        <div className=''>
                            <div className='Gbox'>
                                <Gift />
                            </div>
                            <div className='center choose pt-2'>Earn Cash Back Points</div>
                        </div>
                    </div>
                </div>
                <div className='image-container'>
                    <Service />
                </div>
                <div className='py-3'>
                    <Review />
                </div>
                <div className='OfferBg'>
                    <div className='center  hadding py-4'>Special offer</div>
                    <div className='container'>
                        <div className='row d-flex justify-content-center'>
                            {menu?.slice(0, 6).map((val, key) => (
                                <div className='col-4'> <OfferCard menu={val} /></div>
                            ))}
                        </div>
                    </div>
                    <div className='center py-5'>
                        <div className='viewmore' onClick={handleItem}>More Items</div>
                    </div>
                </div>
                <div>
                    <ContactForm />
                </div>
                <div>
                    <Footer />
                </div>
            </div>
        </div>
    );
};

export default LandingPage;
